import { render, staticRenderFns } from "./ModalFormAduanas.vue?vue&type=template&id=49e9d150"
import script from "./ModalFormAduanas.vue?vue&type=script&lang=js"
export * from "./ModalFormAduanas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports